import * as types from './mutations-types'

export default {
  [types.setPlan] (state, plan) {
    state.plan = plan
  },
  [types.setPlans] (state, plans) {
    state.plans = plans
  },
  [types.setPlanAfterUpdate] (state, payload) {
    state.plans[payload.index].active = payload.plan.active
    state.plans[payload.index].suggested = payload.plan.suggested
  },
  [types.clearPlans] (state) {
    state.plans = []
  },
  [types.setFilterPlan] (state, obj) {
    state.filterPlans[obj.key] = obj.value
  },
  [types.clearFilterPlan] (state, key) {
    delete state.filterPlans[key]
  },
  [types.clearFilterPlans] (state) {
    state.filterPlans = {}
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/plans/vuex/mutations.js